import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import useWindowDimensions from "../../utils/useWindowDimensions";

import {
  reorderedDriversListSelector,
  matrixDaysSelector,
  vehiclesSelector,
  driverProfileLocksSelector,
} from "../../reducers/driverManagement/selectors";
import { onDriverClick } from "../../reducers/ownApp/thunkActions";

import { useLocationDetails } from "../../hooks/useLocationDetails";

import { DriverSortBar } from "./DriverSortBar";
import DriverList from "./DriverList";
import DriverViews from "./DriverViews";
import { View } from "../Base";
import { DriverExtractBar } from "./DriverExtractBar";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const DriverDetail = memo(({ showWorkSchedule }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const drivers = useSelector(reorderedDriversListSelector);
  const driverProfileLocks = useSelector(driverProfileLocksSelector);
  const matrixDays = useSelector(matrixDaysSelector);
  const vehicles = useSelector(vehiclesSelector);
  const { height: windowHeight } = useWindowDimensions();
  const { params = { driverCode: null }, removeParam } = useLocationDetails();

  useEffect(() => {
    if (drivers.length && params.driverCode) {
      drivers.find(({ driverCode }) => driverCode === params.driverCode) &&
        dispatch(onDriverClick({ driverCode: params.driverCode }));
      removeParam("driverCode");
    }
  }, [dispatch, drivers, params.driverCode, removeParam]);

  return (
    <div className={styles.container}>
      <DriverViews />
      <DriverSortBar />
      <View className={styles.list}>
        <DriverList
          showWorkSchedule={showWorkSchedule}
          drivers={drivers}
          driverProfileLocks={driverProfileLocks}
          matrixDays={matrixDays}
          vehicles={vehicles}
          height={windowHeight - 277}
        />
      </View>
      <DriverExtractBar drivers={drivers} />
    </div>
  );
});

export default DriverDetail;
